import {ApiInterface} from '@/plugins/core/api/interface';

const apis: ApiInterface[] = [
  {
    name: 'logger',
    actions: [
      {
        name: 'track',
        method: 'post',
        endpoint: '/api/internal/kvl',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
        },
      },
    ],
  },
];

export default apis;
